// extracted by mini-css-extract-plugin
export default {"table":"style--table--5ac04d","fixed":"style--fixed--387a9d","auto":"style--auto--0b013e","border":"style--border--1b78b8"};